import React from "react"
import PropTypes from "prop-types"
import { Select, Flex } from "antd"
import { useTranslation } from "react-i18next"
import MultiSelect from "components/common/MultiSelect"
import FilterChips from "ui/FilterChips"
import { CATEGORY_OPTIONS } from "../../constants/mockData"
import styles from "./index.module.css"

const EquipmentFilters = ({ selectedCategories, onCategoryChange }) => {
  const { t } = useTranslation()

  return (
    <Flex vertical gap={12}>
      <Flex gap={12}>
        <Select
          placeholder={t("booking.equipment.equipment_pools_placeholder")}
          className={styles.filterSelect}
          style={{ width: 180 }}
        >
          <Select.Option value="all">{t("booking.equipment.all_pools")}</Select.Option>
        </Select>

        <MultiSelect
          value={selectedCategories}
          onChange={onCategoryChange}
          options={CATEGORY_OPTIONS}
          placeholder={t("booking.equipment.category_filter")}
          dropdownClassName={styles.categoryDropdown}
          t={t}
        />
      </Flex>

      <FilterChips selectedValues={selectedCategories} options={CATEGORY_OPTIONS} onChange={onCategoryChange} />
    </Flex>
  )
}

EquipmentFilters.propTypes = {
  selectedCategories: PropTypes.arrayOf(PropTypes.string).isRequired,
  onCategoryChange: PropTypes.func.isRequired
}

export default EquipmentFilters
